type AnalyticsValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | string[]
  | AnalyticsValue[]
  | { [key: string]: AnalyticsValue }

export interface IAnalyticsEventPayload {
  [key: string]: AnalyticsValue
}

export interface IAnalyticsEvent {
  eventName: string
  timestamp: string
  payload?: IAnalyticsEventPayload
  source?: string
  sessionId?: string
  userId?: string
  chatbotId?: string
  tenant?: string
}

export type IAnalyticsCallback = (
  _event: IAnalyticsEvent
) => void | Promise<void>

export interface IAnalyticsService {
  trackEvent(_event: IAnalyticsEvent): void
  setUserContext(_userId?: string, _sessionId?: string): void
  setChatbotContext(_chatbotId?: string, _tenantId?: string): void
  isEnabled(): boolean
}

export const ANALYTICS_EVENTS = {
  CHATBOT_READY: 'chatbot_ready',
  CHATBOT_OPENED: 'chatbot_opened',
  CHATBOT_CLOSED: 'chatbot_closed',
  CHATBOT_MINIMIZED: 'chatbot_minimized',
  TRIGGER_CLICKED: 'trigger_clicked',
  SESSION_STARTED: 'session_started',
  SESSION_RECOVERY_ATTEMPTED: 'session_recovery_attempted',
  SESSION_RECOVERY_SUCCEEDED: 'session_recovery_succeeded',
  SESSION_RECOVERY_FAILED: 'session_recovery_failed',

  QUERY_SUBMITTED: 'query_submitted',
  ANSWER_GENERATED: 'answer_generated',
  ANSWER_COPY_CLICKED: 'answer_copy_clicked',
  NO_RESPONSE_GENERATED: 'no_response_generated',

  REGENERATE_ANSWER_CLICKED: 'regenerate_answer_clicked',
  THUMBS_UP_CLICKED: 'thumbs_up_clicked',
  THUMBS_DOWN_CLICKED: 'thumbs_down_clicked',

  MESSAGE_SENT: 'message_sent',
  BACK_BUTTON_CLICKED: 'back_button_clicked',

  // Follow-up questions
  FOLLOW_UP_QUESTIONS_GENERATED: 'follow_up_questions_generated',
  FOLLOW_UP_QUESTION_CLICKED: 'follow_up_question_clicked',

  // Source documents
  SOURCE_DOCUMENTS_RECEIVED: 'source_documents_received',
  SOURCE_DOCUMENT_CLICKED: 'source_document_clicked',
  SOURCE_PANEL_OPENED: 'source_panel_opened',
  SOURCE_PANEL_CLOSED: 'source_panel_closed',
  INLINE_SOURCES_EXPANDED: 'inline_sources_expanded',
  INLINE_SOURCES_COLLAPSED: 'inline_sources_collapsed',
} as const

export type IAnalyticsEventName =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS]

export const ANALYTICS_SOURCE = 'chatbot' as const

export const SESSION_RECOVERY_REASONS = {
  SESSION_INACTIVE: 'session_inactive',
  NO_CHATBOT_ID: 'no_chatbot_id',
  SESSION_CREATION_FAILED: 'session_creation_failed',
} as const

export type QuestionType = 'typed' | 'suggested' | 'followUp'
